import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ChurchUnitsDataService, CampusStakeDetails, SortService } from '../../shared';
import * as Config from '../../shared/tokens/constants.tokens';
import { finalize } from 'rxjs/operators';

@Component({
  templateUrl: './stake-information.component.html',
  styleUrls: ['./stake-information.component.scss']
})
export class StakeInformationComponent implements OnInit {

  loading = false;
  loadingError = false;
  stakeDetails: CampusStakeDetails;

  constructor(private route: ActivatedRoute, private churchService: ChurchUnitsDataService,
     private titleService: Title, private sorter: SortService, private router: Router) { }

  ngOnInit() {
    const campusStakeId = +this.route.snapshot.paramMap.get('campusStakeId');

    // load the ward's information
    if (campusStakeId) {
      this.loading = true;
      this.churchService.getCampusStakeDetails(campusStakeId)
      .pipe(
        finalize(() => this.loading = false)
      )      
      .subscribe((stakeDetails) => {
            this.handleStakeDetails(stakeDetails);
          },
          error => {
            this.loadingError = true;
          });
      }
  }

  /**
   * Whether or not the loaded ward has a real unit number.
   */
  hasRealUnitNumber(): boolean {
    return this.stakeDetails && this.stakeDetails.unitNumber !== Config.Constants.unassignedUnitNumber;
  }

  /**
   * Handles the results of looking up our stake details.
   */
  private handleStakeDetails(stakeDetails: CampusStakeDetails) {
    this.stakeDetails = stakeDetails;
    if (this.stakeDetails) {
      this.titleService.setTitle(`${this.stakeDetails.name} Information`);

      // sort the wards
      this.stakeDetails.wards.sort(this.sorter.sortChurchUnitsAsc);
    } else {
      // redirect to not found
      this.router.navigate(['/404'], {skipLocationChange: true});
    }
  }
}
